import { Field, Query } from '@tilework/opus';

/** @namespace Steinkrueger/Query/SalesManager/Query */
export class SalesManagerQuery {
    getQuery(): Query<'getSalesManager', string> {
        return new Query<'getSalesManager', any>('getSalesManager')
            .addFieldList(this._getSalesManagerFields());
    }

    _getSalesManagerFields(): Array<
    Field<'manager_id', string, true>
    | Field<'name', string, true>
    | Field<'phone', string, true>
    | Field<'email', string, true>
    > {
        return [
            new Field<'manager_id', string, true>('manager_id'),
            new Field<'name', string, true>('name'),
            new Field<'phone', string, true>('phone'),
            new Field<'email', string, true>('email'),
        ];
    }
}

export default new SalesManagerQuery();
